<div class="c-widget" [ngClass]="{ 'widget--is--loading': isLoading }">
  <div class="c-widget__header" *ngIf="widgetTitle">
    <div class="c-widget__content-left">
      <div class="c-widget__title">
        {{ widgetTitle }}
      </div>
      <button p500-ui-button-icon class="c-button c-button--bordered" (click)="refresh()" type="button">
        <p500-ui-icon name="refresh" size="16px"></p500-ui-icon>
      </button>
    </div>
  </div>
  <ng-content></ng-content>
</div>
